import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f3cc336"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "LikeGoods"
}
const _hoisted_2 = { class: "LikeGoods-header" }
const _hoisted_3 = {
  class: "LikeGoods-list",
  "infinite-scroll-delay": 500
}

import { onMounted, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import GoodsItem from '@/components/common/GoodsItem.vue'
import { getRecommendGoodsList } from '@/apis/goods'
import { useStore } from 'vuex'

import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  // 来源渠道 null-我的频道 1-市场购 2-透明购(平台频道)
  channel: {
    type: String,
    default: null
  },
  // 平台分类 TB-淘宝 TM-天猫 AM-1688
  platformType: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props
const stationCode = useSite2Station()

const store = useStore()

onMounted(() => {
  getList()
})



const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 15,
    total: 0,
    pages: 1
  }
})

// 获取列表
const getList = () => {
  const formData = {
    channel: props.channel,
    platformType: props.platformType,
    mallCategoryId: store.state.market.type,
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    stationCode
  }
  // <!-- 市场购 -1  透明购-2  穿type TB TM AM 我的频道-不传 -->
  getRecommendGoodsList(formData).then((res: any) => {
    if (res?.code === '0') {
      if (formData.pageNum === 1) {
        data.list = res.data.records
        data.page.total = res.data.total
        data.page.pages = res.data.pages
      } else {
        data.list = data.list.concat(res.data.records)
      }
    }
  })
}

// 触底加载
const bottomLoad = () => {
  if (data?.page.currentPage === data.page.pages) {
    return
  }
  data.page.currentPage++
  getList()
}

// item不喜欢操作回调
const itemUnlike = (productCode: string) => {
  const index = data.list.findIndex((item: any) => item.productCode === productCode)
  data.list.splice(index, 1)
}


return (_ctx: any,_cache: any) => {
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_unref(data).list.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('猜你喜欢的商品')), 1),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
            return (_openBlock(), _createBlock(GoodsItem, {
              key: item.productCode,
              item: item,
              showChannel: 2,
              onUnlike: itemUnlike
            }, null, 8, ["item"]))
          }), 128))
        ], 512), [
          [_directive_infinite_scroll, bottomLoad]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})